import AjaxClass from './Validation/ajaxClass';
import FormValidate from './Validation/formValidateClass';
import MessageHandler from './Validation/messageHandler';

export default function forms() {

    $(function () {
        const inputUrl = $('#getAgendamentos');
        const id = inputUrl.attr('data-id');
    
        if (inputUrl.length === 0) {
            console.warn("Input 'getAgendamentos' não encontrado. Requisição não será feita.");
            return;
        }
    
        (async () => {
            const data = await getData(inputUrl.val(), id);
            initForm(data.datasDisponiveis, data.horariosDisponiveis);
        })();
    });
    
    async function getData(url, id) {
        const response = await fetch(url, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
                "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').getAttribute('content') // importante!
            },
            body: JSON.stringify({ id })
        });
    
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }
    
        return await response.json();
    }

    function initForm(datasDisponiveis, horariosDisponiveis) {
        // Inicializa o calendário com a biblioteca flatpickr
        flatpickr("#calendar", {
         dateFormat: "d/m/Y", // Formato da data (ex: 12/03/2025)
         enable: datasDisponiveis, // Habilita somente as datas disponíveis
         locale: "pt", // Define o idioma do calendário como português
         minDate: datasDisponiveis[0], // Define a data mínima
         maxDate: datasDisponiveis[datasDisponiveis.length - 1],
         
         onChange: function (selectedDates, dateStr) {
             // Exibe o loader enquanto os horários estão sendo carregados
             document.getElementById("horariosLoader").style.display = "block";
 
             // Atualiza a lista de horários disponíveis ao selecionar uma data
             let selectHorarios = document.getElementById("select-horarios");
             selectHorarios.innerHTML = ""; // Limpa as opções de horários
 
             setTimeout(() => {  // Simula um carregamento assíncrono com timeout
                 if (horariosDisponiveis[dateStr]) {
                     // Para cada horário disponível na data selecionada, cria a opção no select
                     horariosDisponiveis[dateStr].forEach(item => {
                             let option = document.createElement("option");
                             option.value = item.horario;
                             option.innerText = item.horario;
                             selectHorarios.appendChild(option);

                     });
                     // Exibe o seletor de horários
                     document.getElementById("horarios").style.display = "block";
                     // Preenche o campo oculto com a data selecionada
                 }
                 // Oculta o loader de horários depois de carregar
                 document.getElementById("horariosLoader").style.display = "none";

             }, 1000);  // Tempo simulado para o carregamento dos horários (1 segundo)
         }
     });

     $('#submit-credit').on('click', function(){
        const formValid = $('#form-checkout')[0];
        const form = $('#form-checkout');
        const ingressoInputs = form.find("select[name^='ingressos']");
        let totalSelecionado = 0;
        let peloMenosUmPreenchido = false;
        const limit = $(this).attr('data-limit');
        const sold = $(this).attr('data-sold');
        const disponiveis = limit - sold;

        if (!formValid.checkValidity()) {
            formValid.reportValidity();
            return;
        }

        ingressoInputs.each(function () {
            const quantidade = parseInt(this.value) || 0;
            if (quantidade > 0) {
                peloMenosUmPreenchido = true;
                totalSelecionado += quantidade;
            }
        });

        if (!peloMenosUmPreenchido) {
            const modalErrorDescription = document.querySelector('#error-message-forms .description');
            const modal = document.getElementById('error-message-forms');
            modalErrorDescription.innerHTML = "Selecione pelo menos um ingresso.";
            modal.classList.add('open-modal')
            return;
        }

        if(limit > 0 && totalSelecionado > disponiveis){
            const modalErrorDescription = document.querySelector('#error-message-forms .description');
            const modal = document.getElementById('error-message-forms');
            modalErrorDescription.innerHTML = `Só restam ${limit - sold} ingressos disponíveis.`;
            modal.classList.add('open-modal')
            return;
        }

        const modal = document.getElementById('success-message-credit');
        modal.classList.add('open-modal')
        
    })

    $('.credit-submit-ajax').on('click', function (e){
        const form = $('#form-checkout');
        const button = this; // o botão real clicado
        const paymentMethod = $(button).attr('data-payment');
        const installments = $(button).attr('data-par'); 
        function limpaIngressos(serializedArray) {
            const cleanedArray = serializedArray.filter(field => {
                if (field.name.startsWith("ingressos")) {
                    const valor = parseInt(field.value);
                    return valor && valor > 0;
                }
                return true; 
            });

            if (paymentMethod) {
                cleanedArray.push({
                    name: 'payment_method',
                    value: paymentMethod
                });
                if (installments != ""){
                    cleanedArray.push({
                        name: 'installments',
                        value: installments
                    });
                }
            }
            return $.param(cleanedArray); 
        }
       const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream; 
       if (isIOS) {
            $.ajax({
                url: form.attr('data-url'),
                type: 'GET',
                dataType: 'json',
                data: limpaIngressos(form.serializeArray()),
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                },
                success: function(e){
                    const modalSuccesDescription = document.querySelector('#success-message-pay .description');
                    const modal = document.getElementById('success-message-pay');
                    modalSuccesDescription.innerHTML = 'Obrigado. Clique e acesse a página segura de pagamento!';
                    const paymentLink = document.getElementById('redirect-link');
                    paymentLink.href = e.redirect;   
                    modal.classList.add('open-modal');
                },
                error: function(e){
                    const modalS = document.getElementById('success-message-pay');
                    modalS.classList.remove('open-modal')
                    const modalErrorDescription = document.querySelector('#error-message-forms .description');
                    const modal = document.getElementById('error-message-forms');
                    modalErrorDescription.innerHTML = e.responseJSON?.error || 'Ocorreu um erro inesperado.';
                    modal.classList.add('open-modal')
                }
            })
            return;
        } 
       const modalSuccesDescription = document.querySelector('#success-message-forms .description');
       const modal = document.getElementById('success-message-forms');
       modalSuccesDescription.innerHTML = 'Obrigado. Você será redirecionado a uma pagina segura de pagamento!';
       modal.classList.add('open-modal')
       const modals = document.getElementById('success-message-credit')
       modals.classList.remove("open-modal")
       $.ajax({
           url: form.attr('data-url'),
           type: 'GET',
           dataType: 'json',
           data: limpaIngressos(form.serializeArray()),
           headers: {
               'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
           },
           success: function(e){
                window.open(e.redirect, '_blank');
           },
           error: function(e){
                const modalS = document.getElementById('success-message-forms');
                modalS.classList.remove('open-modal')
                const modalErrorDescription = document.querySelector('#error-message-forms .description');
                const modal = document.getElementById('error-message-forms');
                modalErrorDescription.innerHTML = e.responseJSON?.error || 'Ocorreu um erro inesperado.';
                modal.classList.add('open-modal')
           }
       })
    })


    $('.formEventSend').on('submit', function (e){
        e.preventDefault();
        const form = $(this);
        const button = form.find('button[type="submit"]')[0]; // o botão real clicado
        const paymentMethod = $(button).attr('data-payment');
        let totalSelecionado = 0;
        const limit = $(button).attr('data-limit');
        const sold = $(button).attr('data-sold');
        const disponiveis = limit - sold;

        function limpaIngressos(serializedArray) {
            const cleanedArray = serializedArray.filter(field => {
                if (field.name.startsWith("ingressos")) {
                    const valor = parseInt(field.value);
                    return valor && valor > 0;
                }
                return true; 
            });

            if (paymentMethod) {
                cleanedArray.push({
                    name: 'payment_method',
                    value: paymentMethod
                });
            }
            return $.param(cleanedArray); 
        }

        const ingressoInputs = form.find("select[name^='ingressos']");
        let peloMenosUmPreenchido = false;

        ingressoInputs.each(function () {

            // Verifica se pelo menos um ingresso foi selecionado
            if (parseInt(this.value) > 0) {
                const quantidade = parseInt(this.value) || 0;
                if (quantidade > 0) {
                    peloMenosUmPreenchido = true;
                    totalSelecionado += quantidade;
                }
            }
        });

        if (!peloMenosUmPreenchido) {
            const modalErrorDescription = document.querySelector('#error-message-forms .description');
            const modal = document.getElementById('error-message-forms');
            modalErrorDescription.innerHTML = "Selecione pelo menos um ingresso.";
            modal.classList.add('open-modal')
            return;
        }

       if (!form[0].checkValidity()){
           e.stopPropagation();
           return;
       }

       if(limit > 0 && totalSelecionado > disponiveis){
        const modalErrorDescription = document.querySelector('#error-message-forms .description');
        const modal = document.getElementById('error-message-forms');
        modalErrorDescription.innerHTML = `Só restam ${limit - sold} ingressos disponíveis.`;
        modal.classList.add('open-modal')
        return;
        }
       const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream; 
       if (isIOS) {
            $.ajax({
                url: form.attr('data-url'),
                type: 'GET',
                dataType: 'json',
                data: limpaIngressos(form.serializeArray()),
                headers: {
                    'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                },
                success: function(e){
                    const modalSuccesDescription = document.querySelector('#success-message-pay .description');
                    const modal = document.getElementById('success-message-pay');
                    modalSuccesDescription.innerHTML = 'Obrigado. Clique e acesse a página segura de pagamento!';
                    const paymentLink = document.getElementById('redirect-link');
                    paymentLink.href = e.redirect;   
                    modal.classList.add('open-modal');
                },
                error: function(e){
                    const modalS = document.getElementById('success-message-pay');
                    modalS.classList.remove('open-modal')
                    const modalErrorDescription = document.querySelector('#error-message-forms .description');
                    const modal = document.getElementById('error-message-forms');
                    modalErrorDescription.innerHTML = e.responseJSON?.error || 'Ocorreu um erro inesperado.';
                    modal.classList.add('open-modal')
                }
            })
            return;
        }
       const modalSuccesDescription = document.querySelector('#success-message-forms .description');
       const modal = document.getElementById('success-message-forms');
       modalSuccesDescription.innerHTML = 'Obrigado. Você será redirecionado a uma pagina segura de pagamento!';
       modal.classList.add('open-modal')
       $.ajax({
           url: form.attr('data-url'),
           type: 'GET',
           dataType: 'json',
           data: limpaIngressos(form.serializeArray()),
           headers: {
               'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
           },
           success: function(e){
                window.open(e.redirect, '_blank');
           },
           error: function(e){
                const modalS = document.getElementById('success-message-forms');
                modalS.classList.remove('open-modal')
                const modalErrorDescription = document.querySelector('#error-message-forms .description');
                const modal = document.getElementById('error-message-forms');
                modalErrorDescription.innerHTML = e.responseJSON?.error || 'Ocorreu um erro inesperado.';
                modal.classList.add('open-modal')
           }
       })
    
    })

 }

    
    
    function sendFormWithRecaptcha(form) {
        grecaptcha.ready(function () {
            grecaptcha.execute($("#recaptcha").val(), {
                action: 'submit'
            }).then(function (token) {
                $.ajax({
                    url: form.attr('data-url'),
                    type: 'POST',
                    dataType: 'json',
                    data: form.serialize() + '&gRecaptchaResponse=' + token,
                    headers: {
                        'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content'),
                    },
                    success: function(data){
                        if (data.status == false) {
                            const modal = document.getElementById('error-message-forms');
                            modal.classList.add('open-modal');
                            return;
                        }
                        const modal = document.getElementById('success-message-forms');
                        modal.classList.add("open-modal");
                        form[0].reset();
                    },
                    error: function(e){
                        const modal = document.getElementById('error-message-forms');
                        modal.classList.add('open-modal')
                    }
                })
            });
        });
    }

    $('.formContactSend').on('submit', function (e){
        e.preventDefault();
        const form = $(this);
       if (!form[0].checkValidity()){
           e.stopPropagation();
           return;
       }
        sendFormWithRecaptcha(form);
    })

     $('.formFaqSend').on('submit', function (e){
         e.preventDefault();
         const form = $(this);
        if (!form[0].checkValidity()){
            e.stopPropagation();
            return;
        }
         sendFormWithRecaptcha(form);
     })


    //form precisa ter id também
    $('[form]').on('submit', function (e) {
        e.preventDefault();
        const Loader = document.getElementById("loading-forms")

        let form = $(this);
        let fields = form.serializeArray();
        let validation = new FormValidate(fields, 1, form.attr('id'));

        let images = '';
        if ($(this).find('input[type=file]').length > 0) {
            images = $(this).find('input[type=file]');
            Array.from(images).forEach((e) => {
                let image = {'name': $(e).attr('name'), 'value': $(e)[0].files[0]}
                fields.push(image);
            })
        }

        let selects = $(`#${form.attr('id')} select`).get();
        selects.forEach((element) => {
            if (!$(element).attr('disabled')) {
                let select = {
                    name: $(element).attr('name'),
                    value: $(element).val() ? $(element).val() : '',
                };
                fields.splice(fields.length - 1, 0, select);
            }
        })

        validation.validateAll(fields);
        let error = validation.hasError();
        
        MessageHandler.removeAllFormFailMessages()

        if (error) {
            let errorMessageId = validation.getErrorId();
            MessageHandler.showFailMessage(form.attr('id'), errorMessageId, false);
            return false;
        }

        let terms = $("#" + form.attr('id')).find("input[type='checkbox']");
        if (terms.length > 0) {
            let termsChecked = terms.prop('checked') == true;
            if (!error && !termsChecked){
                error = true
                const id = terms.attr('id');
                MessageHandler.showFailMessage(form.attr('id'), id, false);
                return false;
            }
        }

        if (error == false) {
            Loader.classList.add("open-modal");
            if ($(this).attr('disabled') == 'disabled') {
                return false;
            }
            let formData = form.serialize();
            if (images.length > 0) {
                formData = new FormData();
                fields.forEach(obj => {
                    if (!obj.value) {
                        obj.value = '';
                    }
                    formData.append(obj.name, obj.value);
                });
            }
            $(this).attr('disabled', 'disabled');
            let type = 'POST';
            let url = $(this).attr('action');
            let dataType = 'json';
            const modalSuccess = document.getElementById('success-message-forms');
            const modalSuccessDescription = document.querySelector('#success-message-forms .description');
            const modalError = document.getElementById('error-message-forms');
            const modalDescription = document.querySelector('#error-message-forms .description');
            class Contact extends AjaxClass {
                successFunction(data, form) {
                    Loader.classList.remove("open-modal");
                    if (data.status == true) {
                        $(form).trigger("reset");
                        $(form).removeAttr('disabled');
                        if (data.redirect) {
                            window.location = data.redirect;
                        } else {
                            modalSuccess.classList.add("open-modal");
                            modalSuccessDescription.innerHTML = data.txt
                        }
                    } else {
                        modalDescription.innerHTML = data.txt;
                        modalError.classList.add("open-modal");
                        $(form).removeAttr('disabled');
                    }
                };
                errorFunction(xhr, textStatus, errorThrown) {
                    Loader.classList.remove("open-modal");
                    modalDescription.innerHTML = "Ocorreu um erro. Tente novamente mais tarde.";
                    
                    if (errorThrown == 'Too Many Requests' || xhr.responseText == 'Too Many Requests') {
                        modalDescription.innerHTML = "Muitas tentativas! Aguarde um minuto antes de tentar novamente.";
                    }
                    modalError.classList.add("open-modal");
                    $(form).removeAttr('disabled');
                };
            }
            let ajax = new Contact(form, type, url, dataType, formData);
            ajax.send();
        }

        return false;
    });

    $('[phone]').on('keypress', function (event) {
    // Get the character code of the key pressed
    const charCode = (event.which) ? event.which : event.keyCode;

    // Allow: backspace, delete, tab, escape, enter, home, end, left, right, and period
    if (charCode === 8 || charCode === 46 || charCode === 9 || charCode === 27 ||
        charCode === 13 || charCode === 35 || charCode === 36 || charCode === 37 ||
        charCode === 39 || (charCode === 190 && !this.value.includes('.'))) {
        return;
    }

    // Ensure that it is a number and stop the keypress
    if (charCode < 48 || charCode > 57) {
        event.preventDefault();
    }
    });

    $('[phone]').on('blur', function (e) {
        // mascaraDeTelefone(this);
    });

    $('[phone]').on('focus', function (e) {
        tiraHifen(this);
    });

    function mascaraDeTelefone(telefone){
        const textoAtual = telefone.value.replace(/[^0-9]/g, '');
        const isCelular = textoAtual.length >= 11;
        let textoAjustado;
        if(isCelular) {
            const parte1 = textoAtual.slice(0,2);
            const parte2 = textoAtual.slice(2,4);
            const parte3 = textoAtual.slice(4,9);
            const parte4 = textoAtual.slice(9,13);
            if (parte1)  textoAjustado = `+${parte1}`
            if (parte1 && parte2) textoAjustado = `+${parte1} (${parte2})`
            if (parte1 && parte2 && parte3) textoAjustado = `+${parte1} (${parte2}) ${parte3}`
            if (parte1 && parte2 && parte3 && parte4) textoAjustado = `+${parte1} (${parte2}) ${parte3}.${parte4}`
        } else {
            const parte1 = textoAtual.slice(0,2);
            const parte2 = textoAtual.slice(2,4);
            const parte3 = textoAtual.slice(4,8);
            const parte4 = textoAtual.slice(8,12);
            if (parte1)  textoAjustado = `+${parte1}`
            if (parte1 && parte2) textoAjustado = `+${parte1} (${parte2})`
            if (parte1 && parte2 && parte3) textoAjustado = `+${parte1} (${parte2}) ${parte3}`
            if (parte1 && parte2 && parte3 && parte4) textoAjustado = `+${parte1} (${parte2}) ${parte3}.${parte4}`
        }

        if (!textoAjustado) {
            telefone.value = null;
        } else {
            telefone.value = textoAjustado;
        }
    }
    function tiraHifen(telefone) {
        const textoAtual = telefone.value;
        const textoAjustado = textoAtual.replace(/\./g, '');
    
        telefone.value = textoAjustado;
    }
        
}